var _style, _path, _path2, _path3, _path4, _path5, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgControlShow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t\t.ControlShow-st0 {\r\n\t\t\tfill: currentColor;\r\n\t\t}\r\n\r\n\t\t.ControlShow-st1 {\r\n\t\t\tfill: #666666;\r\n\t\t}\r\n\r\n\t\t.ControlShow-st2 {\r\n\t\t\tdisplay: none;\r\n\t\t\tfill: #666666;\r\n\t\t}\r\n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ControlShow-st0",
    d: "M8.3,24c-0.5,0-0.9-0.4-0.9-0.9v-6.5H0.9c-0.5,0-0.9-0.4-0.9-0.9V8.3c0-0.5,0.4-0.9,0.9-0.9h6.5V0.9 C7.4,0.4,7.8,0,8.3,0h7.5c0.5,0,0.9,0.4,0.9,0.9v6.5l6.8,0.1c0,0,0.1,0,0.3,0.1C23.9,7.7,24,8,24,8.3v7.5c0,0.5-0.4,0.9-0.9,0.9 h-6.5v6.5c0,0.5-0.4,0.9-0.9,0.9L8.3,24L8.3,24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "ControlShow-st1",
    d: "M13.9,4.9c-0.1,0-0.3-0.1-0.3-0.1L12,3.2l-1.6,1.6c-0.1,0.1-0.2,0.1-0.3,0.1S9.8,4.8,9.8,4.8 C9.6,4.7,9.6,4.5,9.6,4.4s0.1-0.3,0.1-0.3l1.9-1.9c0.1-0.1,0.2-0.1,0.3-0.1s0.3,0,0.3,0.1l1.9,1.9c0.3,0.1,0.3,0.2,0.3,0.3 c0,0.1,0,0.3-0.1,0.4S14.1,4.9,13.9,4.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "ControlShow-st1",
    d: "M4.4,14.4c-0.1,0-0.3-0.1-0.3-0.1l-1.9-1.9c-0.1-0.1-0.1-0.2-0.1-0.3s0-0.3,0.1-0.3l1.9-1.9 c0.1-0.3,0.2-0.3,0.3-0.3s0.3,0,0.4,0.1S4.9,9.9,4.9,10s-0.1,0.3-0.1,0.3l-1.6,1.6l1.6,1.7c0.1,0.1,0.1,0.2,0.1,0.3s0,0.3-0.1,0.3 C4.7,14.3,4.5,14.4,4.4,14.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "ControlShow-st1",
    d: "M12,22c-0.1,0-0.3,0-0.3-0.1L9.8,20c-0.2-0.2-0.2-0.3-0.2-0.4s0.1-0.3,0.1-0.3c0.1-0.1,0.2-0.1,0.3-0.1 s0.3,0,0.3,0.1l1.6,1.6l1.6-1.6c0.1-0.1,0.2-0.1,0.3-0.1s0.3,0,0.3,0.1c0.1,0.1,0.1,0.2,0.1,0.3c0,0.1-0.1,0.3-0.1,0.3l-1.9,1.9 C12.2,21.9,12.1,22,12,22z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "ControlShow-st1",
    d: "M19.6,14.4c-0.1,0-0.3,0-0.3-0.1c-0.2-0.2-0.2-0.5,0-0.7l1.6-1.6l-1.7-1.6c-0.1-0.1-0.1-0.2-0.1-0.3 s0-0.3,0.1-0.3c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.3,0,0.3,0.1l1.9,1.9c0.2,0.2,0.2,0.5,0,0.7l-1.9,1.9C19.8,14.4,19.7,14.4,19.6,14.4 z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.3,
    y: -0.4,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -5.043 12.0636)",
    className: "ControlShow-st2",
    width: 1.4,
    height: 25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlShow);
export default __webpack_public_path__ + "static/media/ControlShow.2ca814edf2066915bb51bd8eb3accb67.svg";
export { ForwardRef as ReactComponent };